function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ApolloClient from '../../apollo';
import Info from '../../components/Items/ItemsInfo';
import { useDispatch, useSelector } from 'react-redux';
import { dataItemsLoad } from '../../store/actions/datasetSlice';
function ItemsInfo(props) {
  var _useSelector = useSelector(function (state) {
      return state.dataset && state.dataset.data;
    }),
    loading = _useSelector.loading,
    error = _useSelector.error,
    info = _useSelector.info;
  return /*#__PURE__*/React.createElement(Info, _extends({
    loading: loading,
    error: error,
    info: info
  }, props));
}
ItemsInfo.propTypes = process.env.NODE_ENV !== "production" ? {} : {};
export default ItemsInfo;